module.exports = __webpack_public_path__ + "static/media/cargando.083a79d3.gif";